import React from "react";
import styles from "./styles.module.scss";
import Switcher from "../../../ui/Switcher/Switcher";
import { useDispatch, useSelector } from "react-redux";
import { putAssistant } from "../../../utils/api/actions/assistant";
import { setUpdateAssistant } from "../../../store/slices/assistantSlice";

export const Toggls = () => {
  const dispatch = useDispatch();

  const activeAssistant = useSelector(
    (state) => state?.assistant?.activeAssistant
  );
  const updateAssistant = useSelector(
    (state) => state?.assistant?.updateAssistant
  );

  const startWorkTime = activeAssistant?.settings?.startWorkTime;
  const endWorkTime = activeAssistant?.settings?.endWorkTime;

  const toggleReminderObserver = (bool) => {
    if (activeAssistant) {
      const updAssistant = {
        ...activeAssistant,
        settings: {
          ...activeAssistant.settings,
          useReminder: bool,
        },
      };
      dispatch(putAssistant(updAssistant));
    }
    if (updateAssistant) {
      const updAssistant = {
        ...updateAssistant,
        settings: {
          ...updateAssistant.settings,
          useReminder: bool,
        },
      };
      dispatch(setUpdateAssistant(updAssistant));
    }
  };

  const toggleTimePeriodObserver = (bool) => {
    if (activeAssistant) {
      const updAssistant = {
        ...activeAssistant,
        settings: {
          ...activeAssistant.settings,
          useTimePeriod: bool,
        },
      };
      dispatch(putAssistant(updAssistant));
    }
    if (updateAssistant) {
      const updAssistant = {
        ...updateAssistant,
        settings: {
          ...updateAssistant.settings,
          useTimePeriod: bool,
        },
      };
      dispatch(setUpdateAssistant(updAssistant));
    }
  };

  function formatLabel(from, to) {
    if (from === "01-01-0000 00:00:00" && to === "01-01-0000 00:00:00") {
      return "Работает круглосуточно";
    }

    // Извлекаем только время (HH:MM:SS)
    const formatTime = (dateTime) => dateTime?.split(" ")[1];

    const fromTime = formatTime(from);
    const toTime = formatTime(to);

    return `Работает ${fromTime} - ${toTime}`;
  }

  return (
    <div className={styles.row}>
      <div className={styles.column}>
        <Switcher
          bool={
            updateAssistant
              ? updateAssistant?.settings?.useReminder
              : activeAssistant
              ? activeAssistant?.settings?.useReminder
              : false
          }
          onToggle={toggleReminderObserver}
          label="Напоминания"
        />
        <small style={{ padding: 0 }}>
          При включенной опции ассистент будет использовать напоминания
        </small>
      </div>
      <div className={styles.column}>
        <Switcher
          label={`${formatLabel(startWorkTime, endWorkTime)}`}
          bool={
            updateAssistant
              ? updateAssistant?.settings?.useTimePeriod
              : activeAssistant
              ? activeAssistant?.settings?.useTimePeriod
              : false
          }
          onToggle={toggleTimePeriodObserver}
        />
        <small style={{ padding: 0 }}>
          Ассистент работает в указанный промежуток
        </small>
      </div>
    </div>
  );
};
